import type { GetReceivableSnapshotSummaryParams } from './types';

export const receivableSnapshotKeys = {
  all: ['receivable-snapshots'] as const,
  summaries: () => [...receivableSnapshotKeys.all, 'summary'] as const,
  summary: (filters?: GetReceivableSnapshotSummaryParams) => [...receivableSnapshotKeys.summaries(), filters] as const,
  details: () => [...receivableSnapshotKeys.all, 'detail'] as const,
  detail: (paidDate: string) => [...receivableSnapshotKeys.details(), paidDate] as const,
};

